import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  constructor() { }

  isIEBrowser(): boolean {
    return new RegExp(/msie\s|trident\/|edge\//i).test(window.navigator.userAgent);
  }
}
